import React from "react";
import { Locale } from "@linkfluence/models/locale";
import { Metric } from "@linkfluence/models/metric";
import { useCurrentUserLocale } from "@radarly/core/user/use-cases";
import { tr } from "@radarly/i18n";
import { SearchFragmentUsers, SortInfluencer } from "@radarly/models/search";

function getLabelFromSort(sort: SortInfluencer, locale: Locale) {
  if (sort === Metric.Doc) {
    return tr(locale, "INFLUENCERS::TABLE::COLUMN::POSTS");
  } else if (sort === Metric.Reach) {
    return tr(locale, "INFLUENCERS::TABLE::COLUMN::REACH");
  } else {
    return tr(locale, "INFLUENCERS::TABLE::COLUMN::ENGAGEMENTSHORT");
  }
}

export default function SharedCardsSubtitleAuthorsSort({
  fragment,
}: {
  fragment: SearchFragmentUsers;
}) {
  const locale = useCurrentUserLocale();
  return <>{getLabelFromSort(fragment.request.aggs.users.sort.on, locale)}</>;
}
